// extracted by mini-css-extract-plugin
export var link = "styles-module__link___jYFVO";
export var link48 = "styles-module__link48___B_oJ1";
export var image = "styles-module__image___Ur7mG";